import { I18n } from '../enums/i18n.enum';
import { ButtonsMenuTypes } from '../types/languages.type';

export const languagesData: ButtonsMenuTypes[] = [
  {
    id: 0,
    name: 'فارسی',
    code: I18n.fa,
  },
  {
    id: 1,
    name: 'English',
    code: I18n.en,
  },
  // {
  //   id: ,
  //   name: 'русский',
  //   code: I18n.ru,
  // },
  {
    id: 2,
    name: 'العربية',
    code: I18n.ar,
  },
  {
    id: 3,
    name: 'کوردی',
    code: I18n.ckb,
  },
  {
    id: 4,
    name: 'Türkçe',
    code: I18n.tr,
  },
  {
    id: 5,
    name: '中国人',
    code: I18n.zh,
  },
];
